import { createFileRoute } from '@tanstack/react-router';

import { AdminIntegrationTasksView } from 'src/sections/admin/integration-tasks/admin-integration-tasks-view';

export const Route = createFileRoute('/admin-skidog/integration-tasks')({
  component: AdminIntegrationTasksView,
});
